import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { WithTranslation, withTranslation } from 'react-i18next';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import JournalItem from './JournalItem';
import EmptyState from '../../_partials/EmptyState';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';

import s from './JournalsList.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
}

export class JournalsList extends React.Component<Props & WithTranslation> {
  render() {
    const { items, t, streamId } = this.props;
    if (!items.length) {
      return <EmptyState view="large" />;
    }

    return (
      <div className={s['root']}>
        <DuperbrowseContext
          streamId={streamId}
          deviations={items}
          parent={{ title: t('navigation.route.posts') }}
        >
          {items.map((item, i) => (
            <PostEditableItem
              key={`journal-${i}-${item.deviationId}`}
              className={s['item']}
              item={item}
            >
              <JournalItem item={item} />
            </PostEditableItem>
          ))}
        </DuperbrowseContext>
      </div>
    );
  }
}

export default withTranslation()(JournalsList);
